<template>
  <div class="d-flex justify-space-between full-width" v-if="!createMode">
    <div class="mr-auto pr-2" v-if="node.meta.question">
      {{ node.meta.question }}
    </div>
    <div class="mr-auto pr-2" v-if="node.meta.comment">
      {{ node.meta.comment }}
    </div>
    <div v-if="!editMode">{{ multiValueToString }}</div>
    <span v-if="editMode">
      {{ node.name }}
      <div v-for="choice in node.meta.choices" :key="choice">
        <v-checkbox
          v-if="valueIsEmpty"
          :value="choice"
          :label="choice"
          column
          dense
          :disabled="valueIsEmpty"
        ></v-checkbox>
        <v-checkbox
          v-else
          v-model="node.value[editIndex].val"
          :value="choice"
          :label="choice"
          column
          dense
          @click="changeValue"
        ></v-checkbox>
      </div>
      <div v-if="valueIsEmpty" class="text-caption grey--text text--darken-2">
        This field is disabled until you select a date/time below
      </div>
    </span>
  </div>
  <v-form ref="form" v-else class="full-width">
    <div class="d-flex justify-space-between full-width">
      <v-text-field
        :value="arrayLength"
        :rules="[() => !!parseInt(arrayLength, 10) || 'An entry is required']"
        label="Number of entries"
        required
        type="number"
        @input="setArrayLength($event, node)"
      ></v-text-field>
    </div>
    <div class="d-flex justify-space-between flex-wrap full-width">
      <v-text-field
        v-for="index in parseInt(arrayLength, 10)"
        :key="index"
        v-model="node.meta.choices[index - 1]"
        :rules="[
          () => !!node.meta.choices[index - 1] || 'An entry is required',
        ]"
        :label="`Choice ${index}`"
        required
        :class="{ 'mr-4': index % 3 && index !== parseInt(arrayLength, 10) }"
        @input="validate()"
      ></v-text-field>
    </div>
    <v-row>
      <v-col>
        <div class="d-flex justify-space-between full-width">
          <v-text-field
            label="Question (optional)"
            v-model="node.meta.question"
            class="mr-4"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="d-flex justify-space-between full-width">
          <v-text-field
            label="Tooltip (optional)"
            v-model="node.meta.tooltip"
            class="mr-4"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "MultipleValueList",
  props: {
    node: Object,
    editMode: Boolean,
    editIndex: Number,
    createMode: { type: Boolean, default: false, required: false },
    selectedRecord: Object,
    isRoot: Boolean,
  },
  mounted() {
    if (this.createMode) {
      this.validate();
    }
  },

  data() {
    return {
      arrayLength:
        this.node.meta && this.node.meta.choices
          ? this.node.meta.choices.length
          : 0,
      newValues: [],
    };
  },
  computed: {
    multiValueToString: function() {
      if (this.node.value?.length) {
        const latest = this.node.value.length - 1;
        if (
          typeof this.node.value[latest].val === "string" ||
          this.node.value[latest].val instanceof String
        ) {
          return this.node.value[latest].val;
        }
        return this.node.value[latest].val.join(", ");
      } else {
        return "";
      }
    },
    valueIsEmpty: function() {
      return this.node.value.length === 0;
    },
    ...mapGetters({
      loginDetails: "getUser",
      getName: "getLoggedInName",
    }),
  },
  methods: {
    changeValue() {
      // Changing the value is handled by the v-model
      this.node.value[this.editIndex].authorName = this.getName;
      this.node.value[this.editIndex].authorId = this.loginDetails.id;

      this.$root.$emit("edit:update");
      this.$emit("updateconditionalnodes");
    },
    setArrayLength(e, node) {
      this.arrayLength = e;
      const newLength = parseInt(e, 10);
      if (Number.isNaN(newLength)) {
        return;
      }

      node.value = new Array();
      if (!node.meta.choices || !node.meta.choices.length) {
        Vue.set(node.meta, "choices", new Array(newLength));
      } else {
        if (node.meta.choices.length < newLength) {
          const extraLength = newLength - node.meta.choices.length;
          for (let i in extraLength) {
            node.meta.choices.push("");
          }
        } else if (node.meta.choices.length > newLength) {
          const smallerLength = node.meta.choices.length - newLength;
          node.meta.choices.splice(-smallerLength);
        }
      }
    },
    validate() {
      const okay = this.$refs.form.validate();
      this.$emit("validation", okay);
    },
  },
};
</script>

<style></style>
